import {
	UPDATE_SEARCH_STATE,
	UPDATE_FILTER,
	UPDATE_FILTER_VALUES,
} from '../actionTypes';

// AutoCompleteInput.js, SearchMain.js, SearchResults.js
export const updateSearchState = (content) => ({
	type: UPDATE_SEARCH_STATE,
	payload: {
		content
	}
});

// SearchMain.js
export const updateFilter = (content) => ({
	type: UPDATE_FILTER,
	payload: {
		content
	}
});

// SearchMain.js
export const updateFilterValues = (content) => ({
	type: UPDATE_FILTER_VALUES,
	payload: {
		content
	},
});
